import styled from "styled-components";
//   padding-top: 20px;
const ModalWrapper = styled.div`
  position: fixed;
  z-index: 10;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  // background-color: rgba(0, 0, 0, 0.4);
`;

const ModalBody = styled.div`
  z-index: 10;
  background-color: #ffffff;
  margin: auto;
  padding: 20px;
  border: 1px solid #888;
  position: fixed;
  top: 29vh;
  right: 350px;
  color: #444444;
  text-align: center;
`;

const CloseButton = styled.span`
  color: #aaaaaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
  z-index: 10;
  &:hover,
  &:focus {
    color: #000;
    text-decoration: none;
    cursor: pointer;
  }
`;

export const StyledModal = {
  ModalWrapper,
  ModalBody,
  CloseButton
};


// WEBPACK FOOTER //
// ./src/components/Modal/style.js